import { NavLink, Link, useNavigate, useParams } from 'react-router-dom'
import { FaShare } from 'react-icons/fa'
import { useState, useEffect } from "react";
import { alert_error, alert_success } from "../../AppContext.js";
import classNames from "classnames";
function ProfileNav({ userOption, setUserOption }) {
  const { slug_1 } = useParams();
  const { slug_2 } = useParams();

  const navigate = useNavigate();
  return (
    <div className="flex justify-center mt-0 gap-2">
      <>
        <div
          className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 
            ${(slug_1 == "product" ) ? "border-pink-400" : "border-green-200"}`}
          onClick={() => {
            setUserOption("plans");
            navigate('/shop/accounts/product/home');
          }}
        >
         MMO
        </div>
        <div
          className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 
            ${(slug_1 == "utility" || slug_1 == "plans" || slug_1 == "history") ? "border-pink-400" : "border-green-200"}`}
          onClick={() => {
            setUserOption("plans");
            navigate('/ai/utility/home_vip');
          }}
        >
          🚀 AI
        </div>
        <div
          className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 
            ${userOption === "media" ? "border-pink-400" : "border-green-200"}`}
          onClick={() => {
            setUserOption("media");
            navigate('/shop/orders/media');
          }}
        >
          Social
        </div>
        <div
          className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 
            ${userOption === "traffix" ? "border-pink-400" : "border-green-200"}`}
          onClick={() => {
            setUserOption("traffix");
            navigate('/shop/orders/traffix');
          }}
        >
          Traffix
        </div>
        <div
          className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 
            ${userOption === "check" ? "border-pink-400" : "border-green-200"}`}
          onClick={() => {
            setUserOption("check");
            navigate('/shop/check/orders/posts');
          }}
        >
          Check
        </div>
        <div
          className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 
            ${userOption === "api_docs" ? "border-pink-400" : "border-green-200"}`}
          onClick={() => {
            setUserOption("api_docs");
            navigate('/shop/orders/api_docs');
          }}
        >
          Api
        </div>
      </>
    </div>
  )
}
export default ProfileNav
